import React, { Component } from 'react';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ReactTooltip from 'react-tooltip';

import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import { CheckPermissionComponent } from '../../util/permission';

import IconSidebarParentDashboard from '../../assets/icons/IconSidebarParentDashboard';
import IconSidebarParentTicketList from '../../assets/icons/IconSidebarParentTicketList';
import IconSidebarParentContact from '../../assets/icons/IconSidebarParentContact';
import IconSidebarParentSettings from '../../assets/icons/IconSidebarParentSettings';
import IconSidebarParentMasterData from '../../assets/icons/IconSidebarParentMasterData';
import IconSidebarParentSetup from '../../assets/icons/IconSidebarParentSetup';
import IconSidebarParentReport from '../../assets/icons/IconSidebarParentReport';

import IconSidebarItemPrincipal from '../../assets/icons/IconSidebarItemPrincipal';
import IconSidebarItemManager from '../../assets/icons/IconSidebarItemManager';
import IconSidebarItemLead from '../../assets/icons/IconSidebarItemLead';
import IconSidebarItemOfficer from '../../assets/icons/IconSidebarItemOfficer';

import IconSidebarItemTicketAll from '../../assets/icons/IconSidebarItemTicketAll';
import IconSidebarItemTicketNew from '../../assets/icons/IconSidebarItemTicketNew';
import IconSidebarItemTicketMember from '../../assets/icons/IconSidebarItemTicketMember';
import IconSidebarItemTicketCreate from '../../assets/icons/IconSidebarItemTicketCreate';
import IconSidebarItemSolution from '../../assets/icons/IconSidebarItemSolution';

import IconSidebarItemContact from '../../assets/icons/IconSidebarItemContact';

import IconSidebarItemCsAgent from '../../assets/icons/IconSidebarItemCsAgent';
import IconSidebarItemParameter from '../../assets/icons/IconSidebarItemParameter';
import IconSidebarItemChatbot from '../../assets/icons/IconSidebarItemChatbot';
import IconSidebarItemKMS from '../../assets/icons/IconSidebarItemKMS';
import IconSidebarItemNews from '../../assets/icons/IconSidebarItemNews';
import IconSidebarItemJobProcess from '../../assets/icons/IconSidebarItemJobProcess';
import IconSidebarItemHistory from '../../assets/icons/IconSidebarItemHistory';
import IconSidebarItemQueue from '../../assets/icons/IconSidebarItemQueue';
import IconSidebarItemSession from '../../assets/icons/IconSidebarItemSession';
import IconSidebarItemIssueCategory from '../../assets/icons/IconSidebarItemIssueCategory';
import IconSidebarItemCommissionScheme from '../../assets/icons/IconSidebarItemCommissionScheme';

import IconSidebarItemRole from '../../assets/icons/IconSidebarItemRole';
import IconSidebarItemDataGroup from '../../assets/icons/IconSidebarItemDataGroup';
import IconSidebarItemUser from '../../assets/icons/IconSidebarItemUser';
import IconSidebarItemDataCustomer from '../../assets/icons/IconSidebarItemDataCustomer';
import IconSidebarItemShift from '../../assets/icons/IconSidebarItemShift';
import IconSidebarItemRemark from '../../assets/icons/IconSidebarItemRemark';
import IconSidebarItemImport from '../../assets/icons/IconSidebarItemImport';

import IconSidebarItemReportPrincipal from '../../assets/icons/IconSidebarItemReportPrincipal';
import IconSidebarItemReportExport from '../../assets/icons/IconSidebarItemReportExport';

import {
    TICKET_LIST_ALL_VIEW,
    TICKET_LIST_ALL_VIEW_ASSIGNEE,
    DASHBOARD_CSO_VIEW,
    DASHBOARD_LEAD_VIEW,
    DASHBOARD_MANAGER_VIEW,
    DASHBOARD_PRINCIPAL_VIEW,
    EXPORT_TICKET_VIEW,
    CONTACT_LIST_VIEW,
    TICKET_LIST_SOLUTION_VIEW,
    MASTER_DATA_DATA_CUSTOMER_VIEW,
    MASTER_DATA_DATA_GROUP_VIEW,
    MASTER_DATA_ROLE_VIEW,
    MASTER_DATA_USER_VIEW,
    PROFILE_USER_VIEW,
    PRINCIPAL_TICKET_REPORT_VIEW,
    PRINCIPAL_TICKET_REPORT_VIEW_OWN,
    SETTING_COMMISSION_VIEW,
    SETTING_CS_AGENT_VIEW,
    MASTER_DATA_IMPORT_VIEW,
    SETTING_ISSUE_CATEGORY_INSERT,
    SETTING_ISSUE_CATEGORY_VIEW,
    SETTING_JOB_PROCESS_VIEW,
    SETTING_KMS_VIEW,
    SETTING_LOGIN_HISTORY_VIEW,
    SETTING_PARAMETER_VIEW,
    SETTING_QUEUE_VIEW,
    SETTING_SESSION_VIEW,
    TICKET_CREATE_INSERT,
    TICKET_LIST_MEMBER_VIEW,
    TICKET_LIST_NEW_CSO_VIEW,
    TICKET_LIST_NEW_VIEW,
    TICKET_LIST_NEW_MANAGER_VIEW,
    SETTING_CHATBOT_FLOW_VIEW,
    SETTING_CALL_HISTORY_VIEW,
    SETTING_CALL_HISTORY_VIEW_ASSIGNEE,
    MASTER_DATA_SHIFT_VIEW,
    MASTER_DATA_REMARK_VIEW,
} from '../../constants/menuPermissionConstant';
import IconCallHistory from '../../assets/icons/IconCallHistory';

class Sidebar extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSidebarOpen: true,
            serviceMenuName: ''
        };
    }

    handleSidebar = serviceMenuName => {
        if (this.state.serviceMenuName === serviceMenuName) {
            return this.setState({
                isSidebarOpen: !this.state.isSidebarOpen,
                serviceMenuName: serviceMenuName
            });
        }

        this.setState({
            isSidebarOpen: true,
            serviceMenuName
        });
    };

    handleActiveParentMenu = () => {
        if (window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD)) return this.setState({ serviceMenuName: 'Dashboard' })
        if (window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST)) return this.setState({ serviceMenuName: 'Daftar Tiket' })
        if (window.location.pathname.includes(ROUTER_CONSTANT.CONTACT)) return this.setState({ serviceMenuName: 'Kontak' })
        if (window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS)) return this.setState({ serviceMenuName: 'Pengaturan' })
        if (window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA)) return this.setState({ serviceMenuName: 'Master Data' })
        if (window.location.pathname.includes(ROUTER_CONSTANT.SETUP)) return this.setState({ serviceMenuName: 'Setup' })
        if (window.location.pathname.includes(ROUTER_CONSTANT.REPORT)) return this.setState({ serviceMenuName: 'Laporan' })
        return this.setState({ isSidebarOpen: false })
    }

    componentDidMount() {
        this.handleActiveParentMenu()
    }

    render() {
        return (
            <div className="sidebar">
                <ReactTooltip
                    id="sidemenu"
                    place="right"
                    type="info"
                    effect="solid"
                />
                {/* PARENT MENU */}
                <div className="sidebar-parent-menu">
                    <CheckPermissionComponent permissionConstant={[DASHBOARD_PRINCIPAL_VIEW, DASHBOARD_MANAGER_VIEW, DASHBOARD_LEAD_VIEW, DASHBOARD_CSO_VIEW]} userPermission={this.props.userDetail.permissions}>
                        <div className={this.state.serviceMenuName === 'Dashboard' ? "bg-blue-100 sidebar-parent-icon" : "sidebar-parent-icon"} onClick={() => this.handleSidebar('Dashboard')} data-tip="Dashboard" data-for="sidemenu">
                            <IconSidebarParentDashboard isActive={this.state.serviceMenuName === 'Dashboard'} />
                        </div>
                    </CheckPermissionComponent>

                    <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_VIEW, TICKET_LIST_ALL_VIEW_ASSIGNEE, TICKET_LIST_NEW_VIEW, TICKET_LIST_NEW_CSO_VIEW, TICKET_LIST_NEW_MANAGER_VIEW, TICKET_LIST_MEMBER_VIEW, TICKET_CREATE_INSERT, TICKET_LIST_SOLUTION_VIEW]} userPermission={this.props.userDetail.permissions}>
                        <div className={this.state.serviceMenuName === 'Daftar Tiket' ? "bg-blue-100 sidebar-parent-icon" : "sidebar-parent-icon"} onClick={() => this.handleSidebar('Daftar Tiket')} data-tip="Daftar Tiket" data-for="sidemenu">
                            <IconSidebarParentTicketList isActive={this.state.serviceMenuName === 'Daftar Tiket'} />
                        </div>
                    </CheckPermissionComponent>

                    <CheckPermissionComponent permissionConstant={[CONTACT_LIST_VIEW]} userPermission={this.props.userDetail.permissions}>
                        <div className={this.state.serviceMenuName === 'Kontak' ? "bg-blue-100 sidebar-parent-icon" : "sidebar-parent-icon"} onClick={() => this.handleSidebar('Kontak')} data-tip="Kontak" data-for="sidemenu">
                            <IconSidebarParentContact isActive={this.state.serviceMenuName === 'Kontak'} />
                        </div>
                    </CheckPermissionComponent>

                    <CheckPermissionComponent permissionConstant={[SETTING_CS_AGENT_VIEW, SETTING_PARAMETER_VIEW, SETTING_KMS_VIEW, SETTING_JOB_PROCESS_VIEW, SETTING_LOGIN_HISTORY_VIEW, SETTING_QUEUE_VIEW, SETTING_SESSION_VIEW, SETTING_ISSUE_CATEGORY_VIEW, SETTING_COMMISSION_VIEW, SETTING_CHATBOT_FLOW_VIEW, SETTING_CALL_HISTORY_VIEW, SETTING_CALL_HISTORY_VIEW_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                        <div className={this.state.serviceMenuName === 'Pengaturan' ? "bg-blue-100 sidebar-parent-icon" : "sidebar-parent-icon"} onClick={() => this.handleSidebar('Pengaturan')} data-tip="Pengaturan" data-for="sidemenu">
                            <IconSidebarParentSettings isActive={this.state.serviceMenuName === 'Pengaturan'} />
                        </div>
                    </CheckPermissionComponent>

                    <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_VIEW, MASTER_DATA_ROLE_VIEW, MASTER_DATA_USER_VIEW, MASTER_DATA_DATA_CUSTOMER_VIEW, MASTER_DATA_SHIFT_VIEW, MASTER_DATA_REMARK_VIEW, MASTER_DATA_IMPORT_VIEW]} userPermission={this.props.userDetail.permissions}>
                        <div className={this.state.serviceMenuName === 'Master Data' ? "bg-blue-100 sidebar-parent-icon" : "sidebar-parent-icon"} onClick={() => this.handleSidebar('Master Data')} data-tip="Master Data" data-for="sidemenu">
                            <IconSidebarParentMasterData isActive={this.state.serviceMenuName === 'Master Data'} />
                        </div>
                    </CheckPermissionComponent>

                    <CheckPermissionComponent permissionConstant={[PROFILE_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                        <div className={this.state.serviceMenuName === 'Setup' ? "bg-blue-100 sidebar-parent-icon" : "sidebar-parent-icon"} onClick={() => this.handleSidebar('Setup')} data-tip="Setup" data-for="sidemenu">
                            <IconSidebarParentSetup isActive={this.state.serviceMenuName === 'Setup'} />
                        </div>
                    </CheckPermissionComponent>

                    <CheckPermissionComponent permissionConstant={[PRINCIPAL_TICKET_REPORT_VIEW, PRINCIPAL_TICKET_REPORT_VIEW_OWN, EXPORT_TICKET_VIEW]} userPermission={this.props.userDetail.permissions}>
                        <div className={this.state.serviceMenuName === 'Laporan' ? "bg-blue-100 sidebar-parent-icon" : "sidebar-parent-icon"} onClick={() => this.handleSidebar('Laporan')} data-tip="Laporan" data-for="sidemenu">
                            <IconSidebarParentReport isActive={this.state.serviceMenuName === 'Laporan'} />
                        </div>
                    </CheckPermissionComponent>
                </div>
                {/* SERVICE MENU */}
                <div className={this.state.isSidebarOpen ? "sidebar-service-menu" : "hidden"}>
                    <p className="text-olddarkblue select-none">{this.state.serviceMenuName}</p>
                    <div className="sidebar-line"></div>
                    {/* DASHBOARD */}
                    {
                        this.state.serviceMenuName === 'Dashboard' &&
                        <>
                            <CheckPermissionComponent permissionConstant={[DASHBOARD_PRINCIPAL_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.DASHBOARD_PRINCIPAL} className={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_PRINCIPAL) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemPrincipal isActive={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_PRINCIPAL)} />
                                    </div>
                                    <span>Principal</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[DASHBOARD_MANAGER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.DASHBOARD_MANAGER} className={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_MANAGER) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemManager isActive={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_MANAGER)} />
                                    </div>
                                    <span>Manager</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[DASHBOARD_LEAD_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.DASHBOARD_LEAD} className={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_LEAD) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemLead isActive={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_LEAD)} />
                                    </div>
                                    <span>Lead</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[DASHBOARD_CSO_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.DASHBOARD_OFFICER} className={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_OFFICER) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemOfficer isActive={window.location.pathname.includes(ROUTER_CONSTANT.DASHBOARD_OFFICER)} />
                                    </div>
                                    <span>Officer</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </>
                    }
                    {/* DAFTAR TIKET */}
                    {
                        this.state.serviceMenuName === 'Daftar Tiket' &&
                        <>
                            <CheckPermissionComponent permissionConstant={[TICKET_LIST_ALL_VIEW, TICKET_LIST_ALL_VIEW_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.TICKET_LIST_ALL} className={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemTicketAll isActive={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_ALL)} />
                                    </div>
                                    <span>Tiket Semua</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[TICKET_LIST_NEW_VIEW, TICKET_LIST_NEW_CSO_VIEW, TICKET_LIST_NEW_MANAGER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.TICKET_LIST_NEW} className={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemTicketNew isActive={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_NEW)} />
                                    </div>
                                    <span>Tiket Masuk</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[TICKET_LIST_MEMBER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.TICKET_LIST_MEMBER} className={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemTicketMember isActive={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_MEMBER)} />
                                    </div>
                                    <span>Tiket Anggota</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[TICKET_CREATE_INSERT]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.TICKET_LIST_CREATE} className={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_CREATE) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemTicketCreate isActive={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_CREATE)} />
                                    </div>
                                    <span>Buat Tiket</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[TICKET_LIST_SOLUTION_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.TICKET_LIST_SOLUTION} className={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemSolution isActive={window.location.pathname.includes(ROUTER_CONSTANT.TICKET_LIST_SOLUTION)} />
                                    </div>
                                    <span>Solusi</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </>
                    }
                    {/* KONTAK */}
                    {
                        this.state.serviceMenuName === 'Kontak' &&
                        <>
                            <CheckPermissionComponent permissionConstant={[CONTACT_LIST_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.CONTACT} className={window.location.pathname.includes(ROUTER_CONSTANT.CONTACT) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemContact isActive={window.location.pathname.includes(ROUTER_CONSTANT.CONTACT)} />
                                    </div>
                                    <span>Kontak</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </>
                    }
                    {/* PENGATURAN */}
                    {
                        this.state.serviceMenuName === 'Pengaturan' &&
                        <>
                            <CheckPermissionComponent permissionConstant={[SETTING_CS_AGENT_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_CS_AGENT} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_CS_AGENT) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemCsAgent isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_CS_AGENT)} />
                                    </div>
                                    <span>CS Agent</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_PARAMETER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_PARAMETER} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_PARAMETER) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemParameter isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_PARAMETER)} />
                                    </div>
                                    <span>Parameter</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_CHATBOT_FLOW_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_CHATBOT_FLOW} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_CHATBOT_FLOW) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemChatbot isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_CHATBOT_FLOW)} />
                                    </div>
                                    <span>Flow Chatbot</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_KMS_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_KMS_LIST} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemKMS isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_KMS)} />
                                    </div>
                                    <span>KMS</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_KMS_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_NEWS_FEED} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_NEWS_FEED) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemNews isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_NEWS_FEED)} />
                                    </div>
                                    <span>Berita</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_JOB_PROCESS_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_MONITORING} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_MONITORING) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemJobProcess isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_MONITORING)} />
                                    </div>
                                    <span>Proses Kerja</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_LOGIN_HISTORY_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_LOGIN_HISTORY} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_LOGIN_HISTORY) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemHistory isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_LOGIN_HISTORY)} />
                                    </div>
                                    <span>Riwayat Kerja</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_QUEUE_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_QUEUE_ASSIGNED} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_QUEUE) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemQueue isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_QUEUE)} />
                                    </div>
                                    <span>Antrian</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_SESSION_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_SESSION} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_SESSION) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemSession isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_SESSION)} />
                                    </div>
                                    <span>Pengguna Online</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_ISSUE_CATEGORY_VIEW, SETTING_ISSUE_CATEGORY_INSERT]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemIssueCategory isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_ISSUE_CATEGORY)} />
                                    </div>
                                    <span>Kategori Masalah</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_COMMISSION_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_COMMISSION_SCHEME} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_COMMISSION_SCHEME) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemCommissionScheme isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_COMMISSION_SCHEME)} />
                                    </div>
                                    <span>Skema Komisi</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[SETTING_CALL_HISTORY_VIEW, SETTING_CALL_HISTORY_VIEW_ASSIGNEE]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETTINGS_CALL_HISTORY} className={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_CALL_HISTORY) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconCallHistory isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETTINGS_CALL_HISTORY)} />
                                    </div>
                                    <span>Riwayat Panggilan</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </>
                    }
                    {/* MASTER DATA */}
                    {
                        this.state.serviceMenuName === "Master Data" &&
                        <>
                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_GROUP_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP} className={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemDataGroup isActive={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_DATA_GROUP)} />
                                    </div>
                                    <span>Data Group</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_ROLE_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_ROLE} className={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_ROLE) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemRole isActive={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_ROLE)} />
                                    </div>
                                    <span>Role</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_USER} className={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_USER) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemUser isActive={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_USER)} />
                                    </div>
                                    <span>User</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_DATA_CUSTOMER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_DATA_CUSTOMER} className={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_DATA_CUSTOMER) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemDataCustomer isActive={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_DATA_CUSTOMER)} />
                                    </div>
                                    <span>Data Distributor</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_SHIFT_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_SHIFT} className={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_SHIFT) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemShift isActive={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_SHIFT)} />
                                    </div>
                                    <span>Shift</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_REMARK_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_REMARK} className={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemRemark isActive={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_REMARK)} />
                                    </div>
                                    <span>Remark</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[MASTER_DATA_IMPORT_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.MASTER_DATA_IMPORT} className={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_IMPORT) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemImport isActive={window.location.pathname.includes(ROUTER_CONSTANT.MASTER_DATA_IMPORT)} />
                                    </div>
                                    <span>Import</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </>
                    }
                    {/* SETUP */}
                    {
                        this.state.serviceMenuName === "Setup" &&
                        <>
                            <CheckPermissionComponent permissionConstant={[PROFILE_USER_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.SETUP_PROFILE_SETTINGS} className={window.location.pathname.includes(ROUTER_CONSTANT.SETUP_PROFILE_SETTINGS) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemUser isActive={window.location.pathname.includes(ROUTER_CONSTANT.SETUP_PROFILE_SETTINGS)} />
                                    </div>
                                    <span>Profile</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </>
                    }
                    {/* LAPORAN */}
                    {
                        this.state.serviceMenuName === "Laporan" &&
                        <>
                            <CheckPermissionComponent permissionConstant={[PRINCIPAL_TICKET_REPORT_VIEW, PRINCIPAL_TICKET_REPORT_VIEW_OWN]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET} className={window.location.pathname.includes(ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemReportPrincipal isActive={window.location.pathname.includes(ROUTER_CONSTANT.REPORT_PRINCIPAL_TICKET)} />
                                    </div>
                                    <span>Laporan Tiket Principal</span>
                                </NavLink>
                            </CheckPermissionComponent>

                            <CheckPermissionComponent permissionConstant={[EXPORT_TICKET_VIEW]} userPermission={this.props.userDetail.permissions}>
                                <NavLink to={ROUTER_CONSTANT.REPORT_EXPORT_TICKET} className={window.location.pathname.includes(ROUTER_CONSTANT.REPORT_EXPORT_TICKET) ? "sidebar-menu-item-active bg-darkbluegrey" : "sidebar-menu-item text-gray-600"}>
                                    <div className="w-1/6">
                                        <IconSidebarItemReportExport isActive={window.location.pathname.includes(ROUTER_CONSTANT.REPORT_EXPORT_TICKET)} />
                                    </div>
                                    <span>Eksport Tiket</span>
                                </NavLink>
                            </CheckPermissionComponent>
                        </>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userDetail: state.authentication.userDetail
    };
};

export default withRouter(connect(mapStateToProps, null)(Sidebar));